import React from 'react'
import { Link } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

export const ProductListSort = ({ products }) => {
  // console.log(products)

  return (
    <>
      <Row className="mt-5">

      </Row>
    </>
  )
}

export default ProductListSort